<template>
  <div>
    <users-select v-model="selected"
                  @change="change($event)"
                  :label="$t('users.add-ellipsis')"
                  :filter="filter">
    </users-select>

    <ob-list :items="items" icon="user" :no-data-message="$t('users.no-users')" v-slot="{ item }" @remove="$emit('remove', $event.id)">
      {{ item.user.firstname }} {{ item.user.lastname }} ({{ item.user.code }})
    </ob-list>
  </div>
</template>

<script>
import UsersSelect from './users-select'
import ObList from '../../shared/components/list'

export default {
  name: 'users-in',

  props: [ 'items' ],

  data () {
    return {
      selected: null,
      filter: user => !this.items.some(selItem => selItem.userId === user.id),
    }
  },

  methods: {
    change (id) {
      this.$emit('change', { userId: id })
      this.$nextTick(() => this.selected = null)
    }
  },

  components: {
    ObList,
    UsersSelect
  }
}
</script>

<style scoped lang="scss">

</style>

